import { Injectable } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { EMAIL_REGEX } from '@constants/form.constants';
import { LoginFormConfig } from '@models/form/form.models';
import { FormConfigService } from '../form-config.service';

@Injectable({
  providedIn: 'root',
})
export class LoginFormConfigService
  implements FormConfigService<LoginFormConfig, null>
{
  handleConfigDataChanges(
    _dataChanges: null,
    _formGroup: FormGroup<LoginFormConfig>,
  ): void {
    throw new Error('Method not implemented.');
  }

  createFormConfig(): LoginFormConfig {
    return {
      password: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required],
      }),
      username: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.pattern(EMAIL_REGEX)],
      }),
      rememberMe: new FormControl(false, { nonNullable: true }),
    };
  }

  createValidators(): ValidatorFn[] {
    return [];
  }
}
